import { axiosInstance } from "../axios/axiosHandler";
import { authHeader } from "../store/auth-slice/auth-slice";

export const DownloadFile = async (url : string) => {
    try {
        var header = authHeader();
        const response = await axiosInstance.get(url, {...header, responseType: "blob" });
        let defaultName = "File.xlsx";
    
        if (response.headers['content-disposition']) defaultName = response.headers['content-disposition'].split(";")[2].split("=")[1];
    
        if (defaultName.startsWith("UTF-8''"))
            defaultName = decodeURIComponent(defaultName.replace("UTF-8''", ''))
        else
            defaultName = defaultName.replace(/['"]/g, '')
    
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", defaultName);
        link.click();
    }
    catch (e) {
        console.error('Error occured while trying to download file.')
    }
}